import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { IOsaExecucaoFolhaTesteConsolidadaModel } from "./../../../../../models/osa-execucao-folha-teste-model";
import { OsaExecucaoFolhaTesteService } from "./../../../../../services/osa-execucao-folha-teste.service";
import { IOsaExecucaoProgramaTrabalhoQuestaoModel, IOsaExecucaoProgramaTrabalhoQuestaoPapelTrabalhoModel, IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoModel, IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoRiscoModel } from "./../../../../../models/osa-execucao-programa-trabalho.model";
import { OsaExecucaoProgramaTrabalhoService } from "./../../../../../services/osa-execucao-programa-trabalho.service";
import Swal from "sweetalert2";
import { AuthService } from "./../../../../../services/auth.service";
import { EAvaliacaoProgramaTrabalhoQuestao, EAvaliacaoProgramaTrabalhoQuestaoDescricao } from "../../../../../models/enum/avaliacao-programa-trabalho.enum";
import { OsaExecucaoPapelTrabalhoService } from "./../../../../../services/osa-execucao-papel-trabalho.service";
import { IOsaExecucaoPapelTrabalhoArquivo } from "./../../../../../models/osa-execucao-papel-trabalho.model";
import { OsaExecucaoAbaFolhaTesteProgTrabQuestRespConstaComponent } from "../osa-execucao-aba-folha-teste-prog-trab-quest-resp-consta/osa-execucao-aba-folha-teste-prog-trab-quest-resp-consta.component";

@Component({
  selector: 'app-osa-execucao-aba-folha-teste-programa-trabalho-questao-responder',
  templateUrl: './osa-execucao-aba-folha-teste-programa-trabalho-questao-responder.component.html',
  styleUrls: ['./osa-execucao-aba-folha-teste-programa-trabalho-questao-responder.component.scss']
})
export class OsaExecucaoAbaFolhaTesteProgramaTrabalhoQuestaoResponderComponent implements OnInit {

  public dataSourceAvaliacao = new MatTableDataSource<IOsaExecucaoFolhaTesteConsolidadaModel>([]);
  public dataSourceEvidencias = new MatTableDataSource<IOsaExecucaoProgramaTrabalhoQuestaoPapelTrabalhoModel>([]);
  public dataSourceConstatacoes = new MatTableDataSource<IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoModel>([]);
  public model: IOsaExecucaoProgramaTrabalhoQuestaoModel = {} as IOsaExecucaoProgramaTrabalhoQuestaoModel;
  public tituloModal = "";
  public visualizar = false;
  public id: number = 0;
  public osaExecucaoId: number = 0;
  public enumAvaliacaoProgramaTrabalhoQuestao = EAvaliacaoProgramaTrabalhoQuestao;
  public avaliacoesProgramaTrabalhoQuestao: { text: string, value: number }[] = [];
  public alterandoEvidencia: boolean = false;
  public alterandoConstatacao: boolean = false;
  public unidadeGestoraId: number = 0;
  public planejamentoId: number = 0;
  public proximoIdentificador: string = "C.01";

  constructor(
    public matDialog: MatDialog,
    public osaExecucaoProgramaTrabalhoService: OsaExecucaoProgramaTrabalhoService,
    public osaExecucaoFolhaTesteService: OsaExecucaoFolhaTesteService,
    public osaExecucaoPapelTrabalhoService: OsaExecucaoPapelTrabalhoService,
    public authService: AuthService,
    private dialogRef: MatDialogRef<OsaExecucaoAbaFolhaTesteProgramaTrabalhoQuestaoResponderComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.osaExecucaoId = data?.osaExecucaoId;
    this.id = data?.id;
    this.visualizar = data?.visualizar;
    this.unidadeGestoraId = data?.unidadeGestoraId;
    this.planejamentoId = data?.planejamentoId;
  }

  @ViewChild("tabelaPapelTrabalhoPaginator", { static: true })
  tabelaPapelTrabalhoPaginator: MatPaginator;
  @ViewChild("tabelaPapelTrabalhoSort", { static: true })
  tabelaPapelTrabalhoSort: MatSort;


  @ViewChild("tabelaConstatacaoPaginator", { static: true })
  tabelaConstatacaoPaginator: MatPaginator;
  @ViewChild("tabelaConstatacaoSort", { static: true })
  tabelaConstatacaoSort: MatSort;

  public habilitaFinalizar: boolean = false;
  public valorObservacaoOriginal!: string;
  public valorAvaliacaoOriginal: number | null = null;
  public evidenciasOriginal: IOsaExecucaoProgramaTrabalhoQuestaoPapelTrabalhoModel[] = [];
  public constatacoesOriginal: IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoModel[] = [];

  ngOnInit(): void {

    if (this.visualizar) this.tituloModal = "Visualizar Questão de Auditoria";
    else this.tituloModal = "Avaliar Questão de Auditoria";

    this.carregarListaAvaliacao();

    this.obter(this.id);

  }

  public carregarListaAvaliacao() {
    this.avaliacoesProgramaTrabalhoQuestao = Object.keys(this.enumAvaliacaoProgramaTrabalhoQuestao)
      .filter(key => !isNaN(Number(key)))
      .map(key => ({
        text: EAvaliacaoProgramaTrabalhoQuestaoDescricao[Number(key) as EAvaliacaoProgramaTrabalhoQuestao] ?? '',
        value: Number(key)
      }));
  }

  public obter(id: number) {

    this.osaExecucaoProgramaTrabalhoService
      .obterProgramaTrabalhoQuestaoPorId(id)
      .then((res) => {
        if (res.sucesso) {

          this.model = res.dados;

          this.dataSourceEvidencias.data = res?.dados?.evidencias;
          this.dataSourceEvidencias.paginator = this.tabelaPapelTrabalhoPaginator;
          this.dataSourceEvidencias.sort = this.tabelaPapelTrabalhoSort;
          this.dataSourceEvidencias.sortingDataAccessor = this.sortingDataAccessor;
          this.evidenciasOriginal = [...res?.dados?.evidencias];

          this.dataSourceConstatacoes.data = res?.dados?.constatacoes;
          this.dataSourceConstatacoes.paginator = this.tabelaConstatacaoPaginator;
          this.dataSourceConstatacoes.sort = this.tabelaConstatacaoSort;
          this.dataSourceConstatacoes.sortingDataAccessor = this.sortingConstatacaoDataAccessor;
          this.constatacoesOriginal = [...res?.dados?.constatacoes];

          this.valorObservacaoOriginal = this.model?.observacao ?? null;
          this.valorAvaliacaoOriginal = this.model?.avaliacao ?? null;

          if (this.model.tipo === 1) {
            this.obterAvaliacaoConsolidadaQuestao(this.osaExecucaoId, this.model.questaoId!);
          }
          else {
            this.obterAvaliacaoConsolidadaQuestaoQI(this.osaExecucaoId, this.model.descricao);
          }
          this.verificaAlteracao();

        } else {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "warning",
            text: res.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      });
  }

  public obterAvaliacaoConsolidadaQuestao(osaExecucaoid: number, questaoId: number) {

    this.osaExecucaoFolhaTesteService
      .obterFolhaTesteQuestaoConsolidadaPorExecucaoEQuestao(osaExecucaoid, questaoId)
      .then((res) => {
        if (res.sucesso) {
          this.dataSourceAvaliacao.data = res?.dados;
        } else {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "warning",
            text: res.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      });
  }

  public obterAvaliacaoConsolidadaQuestaoQI(osaExecucaoid: number, descricaoQI: string) {

    this.osaExecucaoFolhaTesteService
      .obterFolhaTesteQuestaoConsolidadaPorExecucaoEDescricaoQI(osaExecucaoid, descricaoQI)
      .then((res) => {
        if (res.sucesso) {
          this.dataSourceAvaliacao.data = res?.dados;
        } else {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "warning",
            text: res.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      });
  }


  public finalizar() {

    if (!this.model.avaliacao) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Informe a avaliação para Finalizar!",
      });
      return;
    }

    if (this.model.avaliacao && this.model.avaliacao === 3 && this.dataSourceConstatacoes.data.length === 0) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "É necessário vincular pelo menos uma constatação quando a avaliação for Inadequada !",
      });
      return;
    }

    if ((!this.model.observacao || this.model.observacao === "") && this.dataSourceEvidencias.data.length === 0) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Na falta de evidências, informe a observação para finalizar!",
      });
      return;
    }

    Swal.fire({
      title: "Finalizar Questão",
      text: "Confirma finalização da Questão?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((res) => {

      if (res.value) {

        const responsavelId = this.authService.usuario.id;
        this.model.responsavelId = responsavelId;
        this.model.status = 2;

        this.osaExecucaoProgramaTrabalhoService
          .atualizarProgramaTrabalhoQuestao(this.model)
          .then((res) => {
            if (res.sucesso) {

              this.dialogRef.close(true);

              Swal.fire({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
                icon: "success",
                text: res.mensagem.descricao,
              });
            } else {
              Swal.fire({
                toast: true,
                position: "top-end",
                icon: "warning",
                text: res.mensagem.descricao,
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
              });
            }
          }).finally(() => {
          });
      }
    })
  }

  public salvar(fechar: boolean) {


    if ((!this.model.observacao || this.model.observacao === "" || this.model.observacao === undefined) && !this.model.avaliacao && this.dataSourceEvidencias.data.length === 0) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "É necessário preencher pelo menos uma informação para salvar o registro!",
      });
      return;
    }

    const responsavelId = this.authService.usuario.id;
    this.model.responsavelId = responsavelId;

    //-> força o status pra em elaboração no salvar
    this.model.status = 1;
   
    this.osaExecucaoProgramaTrabalhoService
      .atualizarProgramaTrabalhoQuestao(this.model)
      .then((res) => {
        if (res.sucesso) {

          if (fechar)
            this.dialogRef.close(true);
          else
            this.obter(this.id);

          Swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            icon: "success",
            text: res.mensagem.descricao,
          });
        } else {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "warning",
            text: res.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      });
  }

  public sortingDataAccessor = (item, property) => {
    switch (property) {
      case "arquivo":
        return item.nomeArquivo;
      default:
        return item[property];
    }
  };

  public sortingConstatacaoDataAccessor = (item, property) => {
    switch (property) {
      case "identificador":
        return item.identificador;
      case "titulo":
        return item.titulo;
      case "tipo":
        return item.tipoDesc;
      case "criterio":
        return item.criterioDesc;
      case "risco":
        return item.riscoDesc;
      default:
        return item[property];
    }
  };

  public excluirEvidencia(element: IOsaExecucaoProgramaTrabalhoQuestaoPapelTrabalhoModel) {

    Swal.fire({
      title: "Excluir Evidência?",
      text: "Confirma exclusão da evidência?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((res) => {

      if (res.value) {

        //-> remove da grade 
        const idx = this.model.evidencias?.findIndex(x => x.id === element.id);
        if (idx !== undefined && idx > -1) {
          this.model.evidencias?.splice(idx, 1);
          this.dataSourceEvidencias.data = [...this.model.evidencias];
        }

        this.alterandoEvidencia = false;

        // desabilita o finalizar
        this.verificaAlteracao();
      }
    });
  }

  public async modalAdicionarConstatacao() {

    this.proximoIdentificador =
      await this.obterProximoIdentificador(
        this.model?.osaExecucaoProgramaTrabalhoId
      );

    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-adicionar-constatacao";
    dialogConfig.width = "70vw";
    dialogConfig.maxHeight = "200vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      id: 0,
      titulo: "Adicionar Constatação",
      visualizar: false,
      identificador: this.proximoIdentificador,
      evidencias: this.model?.evidencias,
      planejamentoId: this.planejamentoId,
      unidadeGestoraId: this.unidadeGestoraId,
      questaoPlanejamentoId: this.model.questaoId,
      observacao: this.model.observacao,
      osaExecucaoProgramaTrabalhoId: this.model.osaExecucaoProgramaTrabalhoId,
      osaExecucaoProgramaTrabalhoQuestaoId: this.model.id
    };

    const modal = this.matDialog.open(
      OsaExecucaoAbaFolhaTesteProgTrabQuestRespConstaComponent,
      dialogConfig
    );

    modal.afterClosed().subscribe((data) => {
      if (data) {
        //-> verifica se a constatação já está vinculada na lista, se estiver nao adiciona 
        const idx = this.model.constatacoes?.findIndex(x => x.identificador === data.identificador);
        if (idx == -1) {
          this.addConstatacao(data);
        }
      }
    });
  }

  public addConstatacao(element: IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoModel) {
    element.id = 0;
    element.osaExecucaoProgramaTrabalhoQuestaoId = this.id;
    this.model.constatacoes.push(element);
    this.dataSourceConstatacoes.data = [...this.model.constatacoes];
    this.alterandoConstatacao = false;
    console.log(this.dataSourceConstatacoes.data);
    // desabilita o finalizar
    this.verificaAlteracao();
  }

  public modalAlterarConstatacao(element: IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoModel) {

    console.log();
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-alterar-constatacao";
    dialogConfig.width = "70vw";
    dialogConfig.maxHeight = "200vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      id: element.id,
      titulo: "Alterar Constatação",
      visualizar: false,
      element,
      evidencias: this.model?.evidencias,
      planejamentoId: this.planejamentoId,
      unidadeGestoraId: this.unidadeGestoraId,
      questaoPlanejamentoId: this.model.questaoId,
      observacao: this.model.observacao,
      osaExecucaoProgramaTrabalhoId: this.model.osaExecucaoProgramaTrabalhoId,
      osaExecucaoProgramaTrabalhoQuestaoId: this.model.id
    };
    const modal = this.matDialog.open(OsaExecucaoAbaFolhaTesteProgTrabQuestRespConstaComponent, dialogConfig);
    modal.afterClosed().subscribe((data) => {
      if (data) {
        //-> inserir na lista de constatações
        this.atualizarConstatacao(data);
      }
    });
  };

  public atualizarConstatacao(element: IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoModel) {
    //-> encontra a constatacao 
    const idx = this.model.constatacoes?.findIndex(x => x.identificador === element.identificador);
    if (idx !== undefined && idx > -1) {
      this.model.constatacoes?.splice(idx, 1);
    }
    this.model.constatacoes.push(element);
    this.dataSourceConstatacoes.data = [...this.model.constatacoes];
    this.alterandoConstatacao = false;
    // desabilita o finalizar
    this.verificaAlteracao();
  }

  public modalVisualizarConstatacao(element: IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoModel) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-visualizar-constatacao";
    dialogConfig.width = "70vw";
    dialogConfig.maxHeight = "200vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      id: element.id,
      titulo: "Visualizar Constatação",
      visualizar: true,
      element,
      evidencias: this.model?.evidencias,
      planejamentoId: this.planejamentoId,
      unidadeGestoraId: this.unidadeGestoraId,
      questaoPlanejamentoId: this.model.questaoId,
      observacao: this.model.observacao,
      osaExecucaoProgramaTrabalhoId: this.model.osaExecucaoProgramaTrabalhoId,
      osaExecucaoProgramaTrabalhoQuestaoId: this.model.id
    };
    const modal = this.matDialog.open(OsaExecucaoAbaFolhaTesteProgTrabQuestRespConstaComponent, dialogConfig);
    modal.afterClosed().subscribe((data) => {
    });
  };

  public excluirConstatacao(element: IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoModel) {

    Swal.fire({
      title: "Excluir Constatação?",
      text: "Confirma exclusão da constatação?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((res) => {

      if (res.value) {

        //-> remove da grade 
        const idx = this.model.constatacoes?.findIndex(x => x.id === element.id);
        if (idx !== undefined && idx > -1) {
          this.model.constatacoes?.splice(idx, 1);
          this.dataSourceConstatacoes.data = [...this.model.constatacoes];
        }

        this.alterandoConstatacao = false;

        // desabilita o finalizar
        this.verificaAlteracao();
      }
    });
  }

  public download(arquivo: IOsaExecucaoPapelTrabalhoArquivo) {
    this.osaExecucaoPapelTrabalhoService.downloadAnexo(arquivo.id).then((res) => {
      if (res.sucesso) {
        const link = document.createElement("a");
        link.href = res.dados.toString(); 0
        link.download = arquivo.nome;
        link.click();
      } else {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "warning",
          text: res.mensagem.descricao,
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      }
    })
  }

  public fechar() {
    this.dialogRef.close(!this.visualizar);
  }

  verificaAlteracao() {

    const normalizar = (valor: any) => {
      if (valor === undefined || valor === null) return null; // trata undefined e null como iguais
      if (typeof valor === 'string') {
        const texto = valor.trim();
        return texto === '' ? null : texto; // trata string vazia como null
      }
      return valor; // mantém outros tipos (número, boolean, etc.)
    };

    const observacaoIgual =
      normalizar(this.model.observacao) === normalizar(this.valorObservacaoOriginal);

    const avaliacaoIgual =
      normalizar(this.model.avaliacao) === normalizar(this.valorAvaliacaoOriginal);

    const evidenciasIguais =
      JSON.stringify(this.model.evidencias ?? []) ===
      JSON.stringify(this.evidenciasOriginal ?? []);

    const constatacoesIguais =
      JSON.stringify(this.model.constatacoes ?? []) ===
      JSON.stringify(this.constatacoesOriginal ?? []);

    this.habilitaFinalizar = observacaoIgual && avaliacaoIgual && evidenciasIguais && constatacoesIguais;
  }

  public async obterProximoIdentificador(id: number): Promise<string> {

    const res = await this.osaExecucaoProgramaTrabalhoService
      .obterProximoIdentificador(id);

    if (!res.sucesso) {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "warning",
        text: res.mensagem.descricao,
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });

      return '';
    }

    const identificadorApi = res.dados;

    if (!this.model.constatacoes || this.model.constatacoes.length === 0) {
      return identificadorApi;
    }

    const extrairNumero = (valor: string) => Number(valor.replace('C.', ''));

    const numeroApi = extrairNumero(identificadorApi);

    const maiorNumeroLista = Math.max(
      ...this.model.constatacoes.map(x =>
        extrairNumero(x.identificador)
      )
    );

    // 🔥 Se API estiver desatualizada
    if (numeroApi <= maiorNumeroLista) {
      const proximoNumero = maiorNumeroLista + 1;
      return `C.${proximoNumero.toString().padStart(2, '0')}`;
    }

    return identificadorApi;
  }

  montarRiscos(riscos: IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoRiscoModel[]): string {
    if (!riscos?.length) return '';
    return riscos
      .map(r => {
        if (r.osaExecucaoProgramaTrabalhoQuestaoIncidentalRiscoId) {
          return r?.osaExecucaoProgramaTrabalhoQuestaoIncidentalRisco?.descricao;
        }
        if (r.matrizRiscoControleRiscosId) {
          return r?.matrizRiscoControleRiscos?.descricaoRisco;
        }
        return r?.descricaoRiscoAvulso;
      })
      .join('\n');
  }
}

